// Экран «Черновики» — тот же черновик, что у задачи, но сам по себе.
//
// **Зачем отдельный.** Черновик к задаче живёт в правой колонке экрана задачи
// и вместе с ней и кончается: прикинуть что-нибудь до того, как задача
// открыта, — например пересчитать пример из учебника или разобрать чужое
// решение, — было негде. Значок в шапке (src/ui/AppNav.tsx) ведёт сюда.
//
// **Почему экран — это одна панель.** Ни заголовка «Черновики», ни строчки о
// том, что это такое. Оба тут были 24 сентября 2026 и в тот же день убраны:
// вместе с шапкой приложения они отодвигали лист на четыре строки вниз, а
// объясняли то, что видно и так. Имя экрана и выход стоят в шапке приложения,
// как на всех остальных экранах; в шапке самой панели — три режима и разворот
// (`variant="page"`, src/ui/Scratch.tsx).
//
// **Почему он один, а не список.** «Черновики» во множественном числе — это
// три режима одной панели (от руки, столбик, доска), а не папка с файлами.
// Черновик не хранится и не называется: решение 3 сентября 2026, оно же
// прописано в UIOptions доски — ни сохранения сцены, ни экспорта.
//
// **Где он лежит.** В том же хранилище черновиков задач (sessionStorage,
// src/lib/task-draft.ts) под своим ключом. Значит: переживает уход на задачу и
// обратно, не переживает закрытие вкладки, и восьмым по счёту черновиком его
// может вытеснить — LRU там на восемь. Для прикидки этого достаточно, а
// «сохранить» здесь обещать нельзя, пока сервер о черновиках не знает.

import { useCallback } from "react";
import { useTaskDraft, type ScratchDraft } from "../lib/task-draft";
import { Scratch } from "../ui/Scratch";

/** Ключ в хранилище черновиков. Совпасть с itemKey задачи не может: у тех
    форма «шаблон:номер», двоеточие здесь отсутствует намеренно. */
const KEY = "scratchpad";

export function Scratchpad() {
  const { draft, update } = useTaskDraft(KEY);
  const setScratch = useCallback(
    (scratch: ScratchDraft): void => update((current) => ({ ...current, scratch })),
    [update],
  );

  return <Scratch variant="page" draft={draft.scratch} onChange={setScratch} />;
}
